import styled from "styled-components";
import * as variables from "../../../styles/variables";

export const FooterLogo = styled.img`
  width: 150px;

  margin-bottom: 10px;
`;

export const Container = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const NavButton = styled.button`
  width: 176px;

  font-size: 1.163rem;
  letter-spacing: 0px;
  font-weight: 400;
  line-height: 3.076em;
  color: ${variables.WHITE};

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 0 10px;

  cursor: pointer;

  :hover {
    color: ${variables.DARK_YELLOW};
    transition: 0.1s ease-in-out;
  }

  @media (max-width: 768px) {
    font-size: 0.963rem;
  }
`;

export const FooterBottomBar = styled.div`
  display: flex;
  justify-content: center; /* Changed to center to align the new text */
  align-items: center;
  //width: 100%;
  padding: 10px 20px;
  //background-color: #222; /* Slightly darker background for the bottom bar */
  border-top: 1px solid #444;
  flex-wrap: wrap; /* Allow items to wrap on smaller screens */
  gap: 10px; /* Space between items when wrapped */

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const FooterCopyright = styled.p`
  font-size: 14px;
  margin: 0;
  color: #bbb;
`;

export const BlueXLogo = styled.img`
  width: 80px; /* Adjust size as needed */
  height: auto;
  margin-left: 5px;
  background: transparent;
`;
